import React from "react";
import NuDate from "../../../../Components/Utils/NuDate";

function EmployeeDetails({ data }) {
  return (
    <div className=" w-full h-full py-3">
      <Title value="Employee Details : " />
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-1 px-2 mt-2">
        <Detail label="ID" value={data?.employeeId || "#"} />
        <Detail label="Name" value={data?.name || "-"} />
        <Detail
          label="Date of Birth"
          value={
            data?.dob ? <NuDate value={data?.dob} format="DD-MMM-YYYY" /> : ""
          }
        />
        <Detail label="Gender" value={data?.gender || "-"} />
      </div>

      <div className=" mt-6">
        <Title value="Address : " />
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-1 px-2 mt-2">
          <Detail label="Address Line One" value={data?.address1 || "-"} />
          <Detail label="Address Line Two" value={data?.address2 || "-"} />
          <Detail label="City" value={data?.city || "-"} />
          <Detail label="State" value={data?.state || "-"} />
          <Detail label="Country" value={data?.country || "-"} />
          <Detail label="Zip / Postal Code" value={data?.country || "-"} />
        </div>
      </div>

      <div className=" mt-6">
        <Title value="Job Details : " />
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-1 px-2 mt-2">
          <Detail label="Position" value={data?.position || "-"} />
          <Detail label="Type" value={data?.type === '1' ? 'Own' : data?.type === '2' ? 'Rental' : '-'} />
          <Detail label="Date of Join" value={data.joiningDate || "-"} />
          <Detail label="Date of Relieving" value={data.leavingDate || "-"} />
          <Detail label="National Id" value={data.department || "-"} />
          <Detail
            label="National-Id Expiry Date"
            value={data.department || "-"}
          />
          <Detail label="Passport Number" value={data.department || "-"} />
          <Detail label="Passport Expiry Date" value={data.department || "-"} />
        </div>
      </div>
      <div className=" mt-6">
        <Title value="Projects : " />
        <div className="grid grid-cols-1 gap-1 px-2 mt-2">
        <Detail
  label={`Assigned Project : ${data?.currentProject?.length || 0}`}
  value={
    data?.currentProjectName?.length > 0 ? (
      <ul className="list-disc list-inside text-[11px] text-gray-400">
        {data.currentProjectName.map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </ul>
    ) : (
      "-"
    )
  }
/>

            {/* <Detail label={`Assigned Project : ${data?.currentProject?.length||0}`} value={data?.currentProjectName.map(item=><p className=" mx-1">{item} ,</p>) || "-"} /> */}
            {/* <Detail label={`Assigned Project : ${data?.projectWorked?.length||0}`} value={data?.projectWorkedName?.map(item=><p className=" mx-1">{item} ,</p>) || "-"} /> */}
        </div>
      </div>
      <div className=" mt-6">
        <Title value="Emergency Contacts : " />
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-1 px-2 mt-2">
            <Detail label="Name" value={data?.emergencyName || "-"} />
            <Detail label="Mobile Number" value={data?.emergencyMobileNo || "-"} />
            <Detail label="Relationship" value={data?.emergencyRelationship || "-"} />
        </div>
      </div>
    </div>
  );
}

export default EmployeeDetails;

export function Title({ value }) {
  return (
    <h1 className=" font-medium text-sm pb-1 text-gray-700 border-b">
      {value}
    </h1>
  );
}

function Detail({ label, value }) {
  return (
    <div className="items-center">
      <p className="font-medium pb-2 text-xs text-gray-600">{label}</p>
      <p className=" text-[11px] text-gray-400">{value}</p>
    </div>
  );
}
